import React, { PureComponent } from 'react';
import Typography from '@material-ui/core/Typography';

class NotFound extends PureComponent {
  render() {
    return (
      <Typography variant="display1"> Page Not Found </Typography>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/views/NotFound.js